import React from 'react';
import { PressTestimonials } from 'components/PressTestimonials/PressTestimonials'; // TODO: remove this component once we fully update modules to use static
//       'PressTestimonials' module. https://classpass.atlassian.net/browse/CRO-1018

export var Press = function Press() {
  return React.createElement("div", {
    className: "bg--white"
  }, React.createElement(PressTestimonials, null));
};